<template>
  <div >
    <NavBar id="topNav" class="container"  ref="NavBar" 
      showLogo="true" showReset="true" showHome="true" 
      :language="language"
      @resetBoard="resetBoard" @goHome="showHomeScreen"
      showDealerTut="false" />
    <Board ref="board" :language="language"/>
    <NavBar id="bottomNav" ref="BottomNavBar" showDealerTut="false" :language="language"/>
  </div>
</template>

<script>
import NavBar from './NavBar'
import html2canvas from 'html2canvas'
import request from 'superagent'
import helpers from '../helpers'
import Board from './GameScreen'


export default {
  name: "BoardBuilder",
  components: {NavBar, Board},
  props: ['language'],
  data(){
    return{
      renderBoard: true,
      newDeck: [
        [55, 56, 57, 58],
        [59, 60, 61, 62],
        [63, 64, 65, 66],
        [67, 68, 69, 70]
      ],
      selected: null,
      selected_pos_one: null,
      selected_pos_two: null,
      output: null,
      showTweetButton: true
    }
  },
  methods: {
    tweet(){
      html2canvas(document.querySelector("#screenshot")).then(canvas => {
        this.showTweetButton = false;
        request
          .post('https://spursloteria.com/api/post-picture')
          .send({ token: '3j4a76BKb5Rzx7s6V2W2WuYG6SW6B24dXy2447CG', media: canvas.toDataURL() })
          .then(res => {
            if(res.status === 200){
              var tweet = "I just completed my #SpursLoteria board. Build yours now for a chance to win tickets: "
              var encodedTweet = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(tweet) + '%20' + encodeURIComponent(res.body.tweet_data.text) + '%20' + encodeURIComponent('https://spurs.com/spurs-loteria');
              if(helpers.isMobile()){
                setTimeout(function () { window.location = encodedTweet }, 25);
                window.location = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(tweet) + '%20' + encodeURIComponent(res.body.tweet_data.text) + '%20' + encodeURIComponent('https://spurs.com/spurs-loteria');
              }else{
                window.location = encodedTweet;
              }
            }
        });
      });
    },
    saveImage(){
      html2canvas(document.querySelector("#screenshot")).then(canvas => {
        var screenshot_data = canvas.toDataURL()
        var url = screenshot_data.replace(/^data:image\/[^;]+/, 'data:application/octet-stream');
        var link = document.createElement("a");
        link.download = 'myboard.png';
        link.href = url;
        link.setAttribute("type", "hidden"); // make it hidden if needed
        document.body.appendChild(link);
        link.click();
      });
    },
    resetBoard(){
      this.$refs.board.resetBoard()
    },
    showHomeScreen(){
      this.$parent.toHome();
    }
  }
};
</script>